'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleBarStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  checked: false,
  disabled: false
};
/** PROP RECEIVERS */

var barBase = function barBase(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.toggleButton.toggleBar,
      width = _theme$reactackle$com.width,
      height = _theme$reactackle$com.height;
  var thumbSize = theme.reactackle.components.toggleButton.toggleThumb.size,
      offsetTop = 'calc((' + (0, _reactackleCore.getValueString)(thumbSize) + ' - ' + (0, _reactackleCore.getValueString)(height) + ') / 2)';
  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(height) + ';\n    top: ' + offsetTop + ';\n  ';
};

var barStyle = function barStyle(_ref2) {
  var themeFromProvider = _ref2.theme,
      checked = _ref2.checked,
      disabled = _ref2.disabled;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var componentPath = theme.reactackle.components.toggleButton.toggleBar.state;
  var source = null;
  if (!disabled) source = checked ? componentPath.checked : componentPath.unchecked;else source = componentPath.disabled;
  var backgroundColor = source.backgroundColor.toString();
  return '\n    background-color: ' + backgroundColor + ';\n  ';
};

var thumbBase = function thumbBase(_ref3) {
  var themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com2 = theme.reactackle.components.toggleButton.toggleThumb,
      size = _theme$reactackle$com2.size,
      borderRadius = _theme$reactackle$com2.borderRadius;
  var barHeight = theme.reactackle.components.toggleButton.toggleBar.height;
  var offsetTop = 'calc((' + (0, _reactackleCore.getValueString)(barHeight) + ' - ' + (0, _reactackleCore.getValueString)(size) + ') / 2)';
  return (0, _styledComponents.css)(['width:', ';height:', ';top:', ';border-radius:', ';'], (0, _reactackleCore.getValueString)(size), (0, _reactackleCore.getValueString)(size), offsetTop, (0, _reactackleCore.getValueString)(borderRadius));
};

var thumbStyle = function thumbStyle(_ref4) {
  var themeFromProvider = _ref4.theme,
      checked = _ref4.checked,
      disabled = _ref4.disabled,
      hover = _ref4.hover,
      focus = _ref4.focus;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var componentPath = theme.reactackle.components.toggleButton.toggleThumb.state;
  var source = null;
  if (!disabled) source = checked ? componentPath.checked : componentPath.unchecked;else source = componentPath.disabled;
  var _source = source,
      backgroundColor = _source.backgroundColor;
  return (0, _styledComponents.css)(['background-color:', ';', ';', ';'], backgroundColor, !disabled && (0, _reactackleCore.boxShadow)(), !disabled && (hover || focus) && (0, _reactackleCore.boxShadow)(2));
};

var thumbPosition = function thumbPosition(_ref5) {
  var checked = _ref5.checked,
      disabled = _ref5.disabled,
      hover = _ref5.hover,
      focus = _ref5.focus,
      themeFromProvider = _ref5.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var hoverOffset = theme.reactackle.components.toggleButton.toggleThumb.hoverOffset;
  var offset = (hover || focus) && !disabled ? (0, _reactackleCore.getValueString)(hoverOffset) : 0;
  var left = checked ? 'auto' : offset;
  var right = checked ? offset : 'auto';
  return '\n    left: ' + left + ';\n    right: ' + right + ';\n  ';
};
/** STYLES */


var ToggleBarStyled = exports.ToggleBarStyled = _styledComponents2.default.label.withConfig({
  displayName: 'ToggleBarStyled'
})(['display:block;position:absolute;left:0;will-change:transform,box-shadow;', ';', ';', ';&::before{content:\'\';position:absolute;', ';', ';', ';', ';}'], barBase, barStyle, (0, _reactackleCore.transition)('background-color'), thumbBase, thumbPosition, thumbStyle, (0, _reactackleCore.transition)('left, box-shadow'));

ToggleBarStyled.propTypes = propTypes;
ToggleBarStyled.defaultProps = defaultProps;
ToggleBarStyled.displayName = 'ToggleBarStyled';